var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreshteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freshteam-logo-vector",
    transform: "translate(131.8 -231.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12948",
    "data-name": "Path 12948",
    d: "M-118.8,257.1a13,13,0,0,1-13-13,13,13,0,0,1,13-13h9.744a3.265,3.265,0,0,1,3.256,3.256v9.768a13,13,0,0,1-13,12.976",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12949",
    "data-name": "Path 12949",
    d: "M-95.374,270.624a6.472,6.472,0,0,0,5.626-3.256,6.509,6.509,0,0,0-5.626-3.232A6.472,6.472,0,0,0-101,267.393a6.509,6.509,0,0,0,5.626,3.232m2.538-10.454a2.567,2.567,0,0,1-2.562,2.571,2.567,2.567,0,0,1-2.562-2.571A2.567,2.567,0,0,1-95.4,257.6a2.567,2.567,0,0,1,2.562,2.571",
    transform: "translate(-23.426 -20.012)",
    fill: "#7052cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshteam);
export default __webpack_public_path__ + "static/media/Freshteam.5e75d27bdf6c10e5651b48fe7c48c28c.svg";
export { ForwardRef as ReactComponent };